import { FormFieldV2 } from '@/components/custom/erp';
import { ExcelOptionsTabProps } from './types';
import { Label } from '@/components/ui/label';

const DEFAULT_ERROR_OPTIONS = [50, 100];

const ExcelOptionsTab = ({ errorOptions = DEFAULT_ERROR_OPTIONS }: ExcelOptionsTabProps) => {
  const options = errorOptions.map(value => ({
    value: String(value),
    label: String(value)
  }));

  return (
    <div className='p-4'>
      <div className='flex items-center gap-4'>
        <Label htmlFor='errors'>Số lỗi trả về tối đa</Label>
        <FormFieldV2 type='select' name='errors' className='w-[200px]' options={options} />
      </div>
    </div>
  );
};

export default ExcelOptionsTab;
